import React, {useMemo, useState} from "react";
import {request} from "../../helper/APIUtils";
import {showAxiosError} from "../../helper/helper";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import Table from "../../components/Table/Table";
import DefaultModal from "../invoice/DefaultModal";
import Select from "../../local_node_modules/react-select";
import {eCommerces} from "../../helper/enums";
import Alert from "react-s-alert";
import {value} from "lodash/seq";
import moment from "moment/moment";
import SweetAlert from "react-bootstrap-sweetalert";
import ReactLoadingTop from "../../components/ReactLoadingTop";
import {Col, FormGroup, Input, Label, Modal, ModalBody, ModalHeader} from "reactstrap";
import MediaViewer from "../einvoice/MediaViewer";
import StickButton from "../../components/StickButton";
import TrendyolSendMultipleModal from "../voucher/component/TrendyolSendMultipleModal";

const ECommerce = (props) => {
    const {currentUser, type} = props;
    const [page, setPage] = useState(0);
    const [size, setSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [content, setContent] = useState([]);
    const [searching, setSearching] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState(null);
    const [prefixCodes, setPrefixCodes] = useState(null);
    const [documentId, setDocumentId] = useState(null);
    const [lastIssueDate, setLastIssueDate] = useState(null);
    const [item, setItem] = useState(null);
    const [index, setIndex] = useState(null);
    const [showSendSwal, setShowSendSwal] = useState(false);
    const [shipmentOrder, setShipmentOrder] = useState(null);
    const [showDeleteSwal, setShowDeleteSwal] = useState(false);
    const [sendLoading, setSendLoading] = useState(false);
    const [istisnaModal, setIstisnaModal] = useState(false);
    const [istisnaStatus, setIstisnaStatus] = useState(null);
    const [shipmentData, setShipmentData] = useState(null);
    const [url, setUrl] = useState(null);
    const [mediaModal, setMediaModal] = useState(false);
    const [title, setTitle] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [gibUser, setGibUser] = useState(false);
    const [selection, setSelection] = useState([]);
    const [selectedInvoice, setSelectedInvoice] = useState([]);
    const [selectedAll, setSelectedAll] = useState(false);
    const [sendType, setSendType] = useState(null);
    const [showSendModal, setShowSendModal] = useState(false);
    const [manual, setManual] = useState(false);
    const [isLoading, setIsLoading] = useState(false);


    const statusTrendyolData = [
        {value: "Created", label: "Yeni Oluşan Siparişler"},
        {value: "Awaiting", label: "Askıda Olan Siparişler"},
        {value: "Picking", label: "Gönderime Hazırlanan Sipariş"},
        {value: "Shipped", label: "Taşıma Durumunda Olan Siparişler"},
        {value: "AtCollectionPoint", label: "PUDO Noktasında Olan Siparişler"},
        {value: "Cancelled", label: "İptal Edilen Siparişler"},
        {value: "UnPacked", label: "Paketi Bölünmüş Siparişler"},
        {value: "Delivered", label: "Teslim Edilen Siparişler"},
        {value: "UnDelivered", label: "Teslim Edilemeyen Siparişler"},
        {value: "UnDeliveredAndReturned", label: "Geri Dönen Siparişler"}
    ];

    const statusCiceksepetiData = [
        {value: "1", label: "Yeni Oluşan Siparişler"},
        {value: "2", label: "Hazırlanan Siparişler"},
        {value: "5", label: "Kargoya Verilen Siparişler"},
        {value: "11", label: "Kargoya Verilecek Olan Siparişler"},
        {value: "7", label: "Teslim Edilen Siparişler"}
    ]

    const statusHepsiburadaData = [
        {value: "OPEN", label: "Açık"},
        {value: "PICKING", label: "Toplama"},
        {value: "PACKING", label: "Paketleme"},
        {value: "SHIPPING", label: "Nakliye"},
        {value: "COMPLETED", label: "Tamamlanmış"},
        {value: "CANCELING", label: "İptal"},
        {value: "REFUNDING", label: "Geri Ödeme"},
        {value: "REFUNDED", label: "İade Edildi"},
        {value: "OUT_OF_STOCK", label: "Stoklar Tükendi"}
    ]

    const statusN11Data = [
        {value: "New", label: "Yeni siparişler"},
        {value: "Approved", label: "Onaylanmış Siparişler"},
        {value: "Rejected", label: "İptal Edilmiş Siparişler"},
        {value: "Shipped", label: "Kargolanmış Siparişler"},
        {value: "Delivered", label: "Teslim Edilen Siparişler"},
        {value: "Completed", label: "Tamamlanmış Siparişler"},
        {value: "Claimed", label: "İptal/İade/Değişim Durumundaki Siparişler"},
        {value: "LATE_SHIPMENT", label: "Kargosu Geciken Siparişler"}
    ]

    const statusIkasData = [
        {value: "CANCELLED", label: "İptal Edildi"},
        {value: "CREATED", label: "Oluşturuldu"},
        {value: "DRAFT", label: "Teslimata Hazır"},
        {value: "PARTIALLY_CANCELLED", label: "Kısmen İptal Edildi"},
        {value: "PARTIALLY_REFUNDED", label: "Kısmen Geri Ödedi"},
        {value: "REFUNDED", label: "İade Edildi"},
        {value: "REFUND_REJECTED", label: "İade Red Edildi"},
        {value: "REFUND_REQUESTED", label: "Geri Ödeme Talep Edildi"}
    ]

    const statusIkas = (status) => {
        switch (status) {
            case "CANCELLED" :
                return "İptal Edildi";
            case "CREATED" :
                return "Oluşturuldu";
            case "DRAFT" :
                return "Teslimata Hazır";
            case "PARTIALLY_CANCELLED" :
                return "Kısmen İptal Edildi";
            case "PARTIALLY_REFUNDED" :
                return "Kısmen Geri Ödedi";
            case "REFUNDED" :
                return "İade Edildi";
            case "REFUND_REJECTED" :
                return "İade Red Edildi";
            case "REFUND_REQUESTED" :
                return "Geri Ödeme Talep Edildi";
            default :
                return '';
        }
    }

    const statusN11 = (status) => {
        switch (status) {
            case 1 :
                return "İşlem Bekliyor";
            case 2 :
                return "İşlemde";
            case 3 :
                return "İptal Edilmiş";
            case 4 :
                return "Geçersiz";
            case 5 :
                return "Tamamlandı";
            default :
                return '';
        }
    }

    const statusPazarama = (status) => {
        switch (status) {
            case 3 :
                return 'Siparişiniz Alındı';
            case 12 :
                return 'Siparişiniz Hazırlanıyor';
            case 13 :
                return 'Tedarik Edilemedi';
            case 5 :
                return 'Siparişiniz Kargoya Verildi';
            case 11 :
                return 'Teslim Edildi';
            case 14 :
                return 'Teslim Edilemedi';
            case 7 :
                return 'İade Süreci Başlatıldı';
            case 8 :
                return 'İade Onaylandı';
            case 9 :
                return 'İade Reddedildi';
            case 10 :
                return 'İade Edildi';
            default :
                return '';
        }
    }
    const statusHepsiburada = (status) => {
        switch (status) {
            case 'OPEN' :
                return 'Açık';
            case 'PICKING' :
                return 'Toplama';
            case 'PACKING' :
                return 'Paketleme';
            case 'SHIPPING' :
                return 'Nakliye';
            case 'COMPLETED' :
                return 'Tamamlanmış';
            case 'CANCELING' :
                return 'İptal';
            case 'REFUNDIG' :
                return 'Geri Ödeme';
            case 'REFUNDED':
                return 'İade Edildi';
            case 'OUT_OF_STOCK':
                return 'Stoklar Tükendi';
            default :
                return '';
        }
    }

    const statusTrendyol = (status) => {
        switch (status) {
            case 'Created':
                return 'Yeni Oluşan Sipariş';
            case 'Awaiting':
                return 'Askıda Olan Sipariş';
            case 'Picking':
                return 'Gönderime Hazırlanan Sipariş';
            case 'Invoiced':
                return 'Faturalı Sipariş';
            case 'Shipped':
                return 'Taşıma Durumunda Olan Sipariş';
            case 'AtCollectionPoint':
                return 'PUDO Noktasında Olan Sipariş';
            case 'Cancelled':
                return 'İptal Edilen Sipariş';
            case 'UnPacked':
                return 'Paketi Bölünmüş Sipariş';
            case 'Delivered':
                return 'Teslim Edilen Siparişler';
            case 'UnDelivered':
                return 'Teslim Edilemeyen Siparişler';
            case 'UnDeliveredAndReturned':
                return 'Geri Dönen Siparişler';
            default :
                return '';
        }
    }

    const statusCiceksepeti = (status) => {
        switch (status) {
            case 1 :
                return 'Yeni Oluşan Siparişler';
            case 2:
                return 'Hazırlanan Siparişler';
            case 5:
                return 'Kargoya Verilen Siparişler';
            case 11 :
                return 'Kargoya Verilecek Olan Siparişler';
            case 7 :
                return 'Teslim Edilen Siparişler';
            default :
                return '';
        }
    }

    const fetchDataTrendyol = (accessor, direction, page, size, searchQueryNew) => {
        let sortStr = accessor !== undefined ? ('&orderByDirection=' + direction.toUpperCase()) : '&orderByDirection=DESC';
        let searchPredicate = searchQueryNew ? (searchQueryNew.lastIndexOf("status") === 1 ? searchQueryNew : `?` + searchQueryNew) : null;
        let search = searchPredicate ? searchPredicate + `&page=${page}&size=${size}${sortStr}` : searchQueryNew ? searchQueryNew + `&page=${page}&size=${size}${sortStr}` : `?${sortStr}&size=${size}&page=${page}`;
        if (searchQueryNew) {
            setSearchQuery(searchPredicate);
        }

        let params = {
            url: '/trendyol/pazaryeri/getShipmentPackages',
            method: "post",
            data: search
        };
        setLoading(true);
        setSearching(true);
        request(params)
            .then((response) => {
                setPage(response.data.body.page);
                setTotal(response.data.body.totalElements);
                setSize(response.data.body.size)
                setContent(response.data.body.content);
                setSearching(false);
                setLoading(false);
                setSelectedInvoice([]);
                setSelection([]);
                setSelectedAll(false);
            }).catch((err) => {
            setSearching(false);
            setLoading(false);
            showAxiosError(err);
        })
    }

    const getGibUserCheck = (item) => {
        let params = {
            url: `/trendyol/pazaryeri/getGibUserCheck`,
            method: "post",
            data: item
        };
        request(params)
            .then(function (response) {
                setGibUser(response.data)
            }).catch(function (error) {
            if (error.response === undefined) {
                showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
            } else {
                let enc = new TextDecoder("utf-8");
                showAxiosError({message: enc.decode(error.response.data)});
            }
        });
    }
    const sendMultiple = (data) => {
        if ((data.sendType === "all" && total > 0) || (selection && selection.length > 0)) {
            setShowSendModal(data.showSendModal);
            setSendType(data.sendType);
        } else {
            Alert.error(((sendType === "all") ? "Toplu gönderilecek doküman bulunamadı" : "Seçili doküman bulunamadı."), {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000,
                html:false
            });
        }
        setIsLoading(false);
    }

    const toggleCheckboxChange = (e, row) => {
        const checked = e.target.checked;
        let newSelections = [...selection];

        if (row === "all") {
            newSelections = checked ? [...content] : [];
            setSelectedAll(checked);
        } else {
            const index = newSelections.findIndex(selectedRow => selectedRow.id === row.id);
            if (index >= 0) {
                newSelections = [
                    ...newSelections.slice(0, index),
                    ...newSelections.slice(index + 1)
                ];
            } else {
                newSelections.push(row);
            }
            setSelectedAll(newSelections.length === content.length);
        }

        setSelection(newSelections);
    };

    const isSelected = useMemo(() => {
        return (id) => selection.some(selectedRow => selectedRow.id === id);
    }, [selection]);


    const downloadMedia = (item, type) => {
        getGibUserCheck(item);
        const parts = item.invoiceLink.split('/');
        const uuid = parts[7];
        const checkControl = "trendyol";
        const vknTckn = gibUser ?
            (item.invoiceAddress ? item.invoiceAddress.taxNumber : item.taxNumber ? item.taxNumber : item.tcIdentityNumber
            ) : (item.taxNumber ? item.taxNumber : item.tcIdentityNumber);
        const formattedDate = toDateTime(item.orderDate);
        const [dayStr, monthStr, yearStr] = formattedDate.split('-');
        const month = parseInt(monthStr, 10);
        const year = parseInt(yearStr, 10);
        const url = gibUser ? `/outbox/downloadMedia/${type}` : `/eArchive/downloadMedia/${type}`;
        let params = {
            url: url,
            responseType: 'arraybuffer',
            method: "post",
            data: {
                documentUuid: uuid,
                year: year,
                month: month,
                checkControl: checkControl,
                vknTckn: vknTckn

            }
        };
        if (type !== "xml")
            setMediaModal(true);
        setTitle(uuid);
        setSelectedItem(item);

        request(params)
            .then(function (response) {
                let blob = new Blob([response.data], {type: response.headers["content-type"]});
                let urlCreator = window.URL || window.webkitURL;
                let url = urlCreator.createObjectURL(blob);
                if (type !== "xml" && type !== "download_html") {
                    setUrl(url);
                } else {
                    let a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    if(type === "download_html"){
                        a.download = item.orderNumber + "_" + uuid + ".html";
                    } else{
                        a.download = item.orderNumber + "_" + uuid + ".xml";
                    }
                    a.click();
                }
            }).catch(function (error) {
            if (error.response === undefined) {
                showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
            } else {
                let enc = new TextDecoder("utf-8");
                showAxiosError({message: enc.decode(error.response.data)});
            }
            setMediaModal(false);
            setTitle(null);
        });
    }

    const controlInvoiceLink = (invoiceLink) => {
        if (invoiceLink != null){
            let sonuc = (!(invoiceLink.includes("portal.kolaysoft.com.tr") ||
                invoiceLink.includes("portal.smartdonusum.com") ||
                invoiceLink.includes("portal.mbtfatura.com.tr")));
            return sonuc;
        }else {
            return true;
        }
    }


    const setMediaViewer = () => {
        setUrl(null);
        setMediaModal(false);
    }

    const sendFromViewer = (item, index) => {
        setMediaModal(false);
        // this.handleSend(item, index);
    }

    const fetchDataCiceksepeti = (accessor, direction, page, size, searchQueryNew) => {

        let queryPayload = {
            page: page,
            pageSize: size,
            startDate: searchQueryNew === null || searchQueryNew === undefined ? (searchQuery === null ? null : (searchQuery.startDate.value !== undefined ? searchQuery.startDate.value : null)) : (searchQueryNew.startDate.value !== undefined ? searchQueryNew.startDate.value : null),
            endDate: searchQueryNew === null || searchQueryNew === undefined ? (searchQuery === null ? null : (searchQuery.endDate.value !== undefined ? searchQuery.endDate.value : null)) : (searchQueryNew.endDate.value !== undefined ? searchQueryNew.endDate.value : null),
            orderNo: searchQueryNew === null || searchQueryNew === undefined ? (searchQuery === null ? null : (searchQuery.orderNo.value !== undefined ? searchQuery.orderNo.value : null)) : (searchQueryNew.orderNo.value !== undefined ? searchQueryNew.orderNo.value : null),
            statusId: searchQueryNew === null || searchQueryNew === undefined ? (searchQuery === null ? null : (searchQuery.status?.value !== undefined ? searchQuery.status?.value : null)) : (searchQueryNew.status?.value !== undefined ? searchQueryNew.status?.value : null),
            isOrderStatusActive: searchQueryNew === null || searchQueryNew === undefined ? (searchQuery === null ? true : (searchQuery.isOrderStatusActive?.value !== undefined ? searchQuery.isOrderStatusActive?.value : true)) : (searchQueryNew.isOrderStatusActive?.value !== undefined ? searchQueryNew.isOrderStatusActive?.value : true)
        }

        let params = {
            url: '/ciceksepeti/getOrderList',
            method: "post",
            data: queryPayload
        };
        setLoading(true);
        setSearching(true);
        request(params)
            .then((response) => {
                setPage(page);
                setTotal(response.data.orderListCount);
                // setSize(response.data.body.size)
                setContent(response.data.supplierOrderListWithBranch);
                setSearching(false);
                setLoading(false);
            }).catch((err) => {
            setSearching(false);
            setLoading(false);
            showAxiosError(err);
        })
    }

    const fetchDataHepsiburada = (accessor, direction, page, size) => {
        let search = searchQuery ? searchQuery + `&page=${page}&size=${size}` : `?size=${size}&page=${page}&status=OPEN`;

        let params = {
            url: `/hepsiburada/getOrderList`,
            method: "post",
            data: search
        }
        setLoading(true);
        setSearching(true);
        request(params)
            .then((response) => {
                setSearching(false);
                setLoading(false);
            }).catch((err) => {
            setSearching(false);
            setLoading(false);
            showAxiosError(err);
        })
    }

    const fetchDataN11 = (accessor, direction, page, size, dataSearchQuery) => {

        let queryRequest = {
            startDate: dataSearchQuery === null || dataSearchQuery === undefined ? (searchQuery === null ? null : (searchQuery.startDate?.value !== undefined ? searchQuery.startDate.value : null)) : (dataSearchQuery.startDate?.value !== undefined ? dataSearchQuery.startDate.value : null),
            endDate: dataSearchQuery === null || dataSearchQuery === undefined ? (searchQuery === null ? null : (searchQuery.endDate?.value !== undefined ? searchQuery.endDate.value : null)) : (dataSearchQuery.endDate?.value !== undefined ? dataSearchQuery.endDate.value : null),
            orderStatus: dataSearchQuery === null || dataSearchQuery === undefined ? (searchQuery === null ? null : (searchQuery.status?.value !== undefined ? searchQuery.status.value : null)) : (dataSearchQuery.status?.value !== undefined ? dataSearchQuery.status.value : null),
            recipient: null,
            buyerName: null,
            orderNumber: dataSearchQuery === null || dataSearchQuery === undefined ? (searchQuery === null ? null : (searchQuery.orderNumber?.value !== undefined ? searchQuery.orderNumber.value : null)) : (dataSearchQuery.orderNumber?.value !== undefined ? dataSearchQuery.orderNumber.value : null),
            productSellerCode: null,
            productIdValue: null,
            pageValue: page,
            pageSize: size
        }

        let params = {
            url: `/n11/getOrderList`,
            method: "post",
            data: queryRequest
        }
        setLoading(true);
        setSearching(true);
        request(params)
            .then((response) => {
                setTotal(response.data.body.pagingData.totalCount);
                setPage(page);
                setContent(response.data.body.orderList.order)
                setSearching(false);
                setLoading(false);
            }).catch((err) => {
            setSearching(false);
            setLoading(false);
            showAxiosError(err);
        })
    }
    const fetchDataPazarama = (accessor, direction, page, size, searchQueryNew) => {

        let queryPayload = {
            pageNumber: page + 1,
            pageSize: size,
            startDate: searchQueryNew === null || searchQueryNew === undefined ? (searchQuery === null ? null : (searchQuery.startDate.value !== undefined ? searchQuery.startDate.value : null)) : (searchQueryNew.startDate.value !== undefined ? searchQueryNew.startDate.value : null),
            endDate: searchQueryNew === null || searchQueryNew === undefined ? (searchQuery === null ? null : (searchQuery.endDate.value !== undefined ? searchQuery.endDate.value : null)) : (searchQueryNew.endDate.value !== undefined ? searchQueryNew.endDate.value : null)
        }

        let params = {
            url: `/pazarama/getOrderList`,
            method: "post",
            data: queryPayload
        }
        setLoading(true);
        setSearching(true);
        request(params)
            .then((response) => {
                setContent(response.data.body.data)
                setPage(queryPayload.pageNumber - 1);
                setTotal((page + 2) * size)
                setSize(queryPayload.pageSize);
                setSearching(false);
                setLoading(false);
            }).catch((err) => {
            setSearching(false);
            setLoading(false);
            showAxiosError(err);
        })
    }

    const fetchDataIkas = (accessor, direction, page, size, searchQueryNew) => {

        let queryPayload = {
            page: page + 1,
            limit: size,
            status: searchQueryNew?.status.value === undefined ? null : searchQueryNew.status.value
        }

        let params = {
            url: `/ikas/getOrderList`,
            method: "post",
            data: queryPayload
        }
        setLoading(true);
        setSearching(true);
        request(params)
            .then((response) => {
                setContent(response.data.body.data.listOrder.data);
                setPage(response.data.body.data.listOrder.page - 1);
                setTotal(response.data.body.data.listOrder.count);
                setSearching(false);
                setLoading(false);
            }).catch((err) => {
            setSearching(false);
            setLoading(false);
            showAxiosError(err);
        })
    }


    const handleSearch = (searchQueryNew) => {
        setSearching(true);
        setSearchQuery(searchQueryNew ?? null);
        if (eCommerces.CICEKSEPETI === type) {
            fetchDataCiceksepeti(undefined, null, 0, size, searchQueryNew !== null && searchQueryNew !== '' ? searchQueryNew : null);
        } else if (eCommerces.TRENDYOL === type) {
            fetchDataTrendyol(undefined, null, 0, size, searchQueryNew !== null && searchQueryNew !== '' ? searchQueryNew : null);
        } else if (eCommerces.HEPSIBURADA === type) {
            fetchDataHepsiburada(undefined, null, 0, size, searchQueryNew ? searchQueryNew : null);
        } else if (eCommerces.PAZARAMA === type) {
            fetchDataPazarama(undefined, null, 0, size, searchQueryNew ? searchQueryNew : null);
        } else if (eCommerces.IKAS === type) {
            fetchDataIkas(undefined, null, 0, size, searchQueryNew ? searchQueryNew : null);
        } else if (eCommerces.N11 === type) {
            fetchDataN11(undefined, null, 0, size, searchQueryNew ? searchQueryNew : null);
        }
    }

    const istisnaCheck = (item, index) => {
        const istisna = item.lines.find(f => f.vatBaseAmount === 0);

        if (istisna !== undefined && istisna !== null) {
            setIstisnaModal(true);
            setShipmentData(item);
        } else {
            trendyolDataToInvoiceData(item, index);
        }
    }


    const sendIstisnaData = (istisnaCode) => {
        setSendLoading(true);
        let params = {
            url: '/trendyol/pazaryeri/createInvoice/' + istisnaCode,
            method: "post",
            data: shipmentData
        }

        request(params)
            .then((response) => {
                Alert.success(response.data, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000,
                    html: false
                });
                setSendLoading(false);
            }).catch((err) => {
            showAxiosError(err)
            setSendLoading(false);
        })
        setIstisnaStatus(null)
    }

    const trendyolDataToInvoiceData = (item, index) => {
        setSendLoading(true);
        let params = {
            url: '/trendyol/pazaryeri/createInvoice/' + 0,
            method: "post",
            data: item
        }

        request(params)
            .then((response) => {
                Alert.success(response.data, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000,
                    html: false
                });
                setSendLoading(false);
            }).catch((err) => {
            showAxiosError(err)
            setSendLoading(false);
        })
    }

    const deleteInvoiceLink = () => {
        setShowDeleteSwal(false);
        setSendLoading(true);
        let params = {
            url: '/trendyol/pazaryeri/deleteInvoiceLink',
            method: "post",
            data: {
                shipmentPackageId: shipmentOrder.id,
                trendyolCustomerId: shipmentOrder.customerId
            }
        };

        request(params).then((response) => {
            setShipmentOrder(null);
            setSendLoading(false);
        }).catch(error => {
            showAxiosError(error);
            setSendLoading(false);
        });
    }

    const ciceksepetiDataToInvoiceData = (item, index) => {
        let params = {
            url: '/ciceksepeti/createInvoice',
            method: "post",
            data: item
        }

        request(params)
            .then((response) => {
                Alert.success("Fatura Gönderimi Başarılı.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            }).catch((err) => {
            showAxiosError(err)
        })
    }

    const n11DataToInvoiceData = (item, index) => {

        let params = {
            url: '/n11/getOrderDetail',
            method: "post",
            data: item.id
        }

        request(params)
            .then((response) => {
                Alert.success("Fatura Gönderimi Başarılı.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            }).catch((err) => {
            showAxiosError(err)
        })
    }

    const ikasDataToInvoiceData = (item, index) => {

        let params = {
            url: '/ikas/createInvoice',
            method: "post",
            data: item
        }

        request(params)
            .then((response) => {
                Alert.success("Fatura Gönderimi Başarılı.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            }).catch((err) => {
            showAxiosError(err)
        })
    }

    const pazaramaDataToInvoiceData = (item, index) => {
        let params = {
            url: '/pazarama/createInvoice',
            method: "post",
            data: item
        }

        request(params)
            .then((response) => {
                Alert.success("Fatura Gönderimi Başarılı.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            }).catch((err) => {
            showAxiosError(err)
        })
    }

    const confirmSend = () => {

    }

    const columnsTrendyol = [
        {
            Header: (<input type="checkbox" checked={selectedAll}
                            onChange={(e) => toggleCheckboxChange(e, "all", "id")}/>),
            accessor: "id",
            selectType: "checkbox",
            sortable: false,
            Cell: (row, index) => (<input type="checkbox" checked={isSelected(row.id)}
                                          onChange={(e) => toggleCheckboxChange(e, row)}/>)
        },
        {
            accessor: [
                {
                    Header: "Sipariş Numarası",
                    accessor: "orderNumber",
                    sortable: false,
                }
            ],
            sort: false,
            Cell: row => (<div>{row.orderNumber}</div>)
        },
        {
            accessor: [
                {
                    Header: "Sipariş Tarihi",
                    accessor: "",
                    sortable: true,
                }
            ],
            sort: false,
            Cell: row => (<div>{toDateTime(row.orderDate)}</div>)
        },
        {
            accessor: [
                {
                    Header: "Fatura Tutarı",
                    accessor: "totalPrice",
                    sortable: false,
                }
            ],
            Cell: row => (<div>{row.totalPrice + " TRY"}</div>)
        },
        {
            accessor: [
                {
                    Header: "Durumu",
                    accessor: "status",
                    sortable: false,
                }
            ],
            Cell: row => (<div>{statusTrendyol(row.status)}</div>)
        },
        {
            Header: "İşlemler",
            accessor: "",
            sortable: false,
            width: "11%",
            Cell: (item, index) => (
                <div>
                    <button type="button" onClick={() => istisnaCheck(item, index)} rel="tooltip"
                            className="Btn btn-icon" title="Fatura Gönder"
                        // disabled={item.totalPrice !== 0 && (item.status === 'Created' || item.status === 'Picking') ? false : true}
                            disabled={item.totalPrice !== 0 && (item.status === 'Cancelled') || (item.invoiceLink) ? true : false}
                            style={{background: 'rgb(52, 216, 103)'}}>
                        <i className="fa fa-send"/>
                    </button>
                    <button type="button" onClick={() => downloadMedia(item, "pdf")} rel="tooltip"
                            className="Btn btn-icon" title="Fatura PDF İndir"
                            disabled={item.status === 'Cancelled' || controlInvoiceLink(item.invoiceLink)}
                            style={{background: 'rgb(158, 158, 158)'}}>
                        <i className="fa fa-eye"/>
                    </button>

                    {/*<button type="button" onClick={() => {*/}
                    {/*    setShowDeleteSwal(true);*/}
                    {/*    setShipmentOrder(item);*/}
                    {/*}} rel="tooltip"*/}
                    {/*        className="Btn btn-icon" title="Fatura Sil"*/}
                    {/*        style={{background: 'rgb(255,25,25)'}}>*/}
                    {/*    <i className="fas fa-trash"/>*/}
                    {/*</button>*/}
                </div>
            )
        }
    ];

    const columnsCiceksepeti = [
        {
            Header: "#",
            accessor: "recordId",
            sortable: false,
            Cell: (row, index) => (<div style={{margin: 0}}>{index + 1}</div>)
        },
        {
            accessor: [
                {
                    Header: "Sipariş Numarası",
                    accessor: "orderId",
                    sortable: false,
                }
            ],
            sort: false,
            Cell: row => (<div>{row.orderId}</div>)
        },
        {
            accessor: [
                {
                    Header: "Sipariş Tarihi",
                    accessor: "",
                    sortable: true,
                }
            ],
            sort: false,
            Cell: row => (<div>{row.orderCreateDate}</div>)
        },
        {
            accessor: [
                {
                    Header: "Fatura Tutarı",
                    accessor: "invoicePrice",
                    sortable: false,
                }
            ],
            Cell: row => (<div>{row.invoicePrice + " TRY"}</div>)
        },
        {
            accessor: [
                {
                    Header: "Durumu",
                    accessor: "orderProductStatus",
                    sortable: false,
                }
            ],
            Cell: row => (<div>{statusCiceksepeti(row.orderItemStatusId)}</div>)
        },
        {
            Header: "",
            accessor: "",
            sortable: false,
            width: "11%",
            Cell: (item, index) => (
                <div>
                    <button type="button" onClick={() => ciceksepetiDataToInvoiceData(item, index)} rel="tooltip"
                            className="Btn btn-icon" title="Fatura Gönder"
                            disabled={(item.orderItemStatusId === 1 || item.orderItemStatusId === 2 || item.orderItemStatusId === 11) && item.invoicePrice !== 0 ? false : true}
                            style={{background: 'rgb(52, 216, 103)'}}>
                        <i className="fa fa-send"/>
                    </button>
                </div>
            )
        }
    ];

    const columnsPazarama = [
        {
            Header: "#",
            accessor: "recordId",
            sortable: false,
            Cell: (row, index) => (<div style={{margin: 0}}>{index + 1}</div>)
        },
        {
            accessor: [
                {
                    Header: "Sipariş Numarası",
                    accessor: "orderNumber",
                    sortable: false,
                }
            ],
            sort: false,
            Cell: row => (<div>{row.orderNumber}</div>)
        },
        {
            accessor: [
                {
                    Header: "Sipariş Tarihi",
                    accessor: "",
                    sortable: true,
                }
            ],
            sort: false,
            Cell: row => (<div>{moment(row.orderDate).format("DD-MM-YYYY")}</div>)
        },
        {
            accessor: [
                {
                    Header: "Fatura Tutarı",
                    accessor: "invoicePrice",
                    sortable: false,
                }
            ],
            Cell: row => (<div>{row.orderAmount + " TRY"}</div>)
        },
        {
            accessor: [
                {
                    Header: "Durumu",
                    accessor: "orderStatus",
                    sortable: false,
                }
            ],
            Cell: row => (<div>{statusPazarama(row.orderStatus)}</div>)
        },
        {
            Header: "",
            accessor: "",
            sortable: false,
            width: "11%",
            Cell: (item, index) => (
                <div>
                    <button type="button" onClick={() => pazaramaDataToInvoiceData(item, index)} rel="tooltip"
                            className="Btn btn-icon" title="Fatura Gönder"
                            style={{background: 'rgb(52, 216, 103)'}}>
                        <i className="fa fa-send"/>
                    </button>
                </div>
            )
        }
    ];

    const columnsHepsiburada = [
        {
            Header: "#",
            accessor: "recordId",
            sortable: false,
            Cell: (row, index) => (<div style={{margin: 0}}>{index + 1}</div>)
        },
        {
            accessor: [
                {
                    Header: "Sipariş Numarası",
                    accessor: "merchantOrderNumber",
                    sortable: false,
                }
            ],
            sort: false,
            Cell: row => (<div>{row.merchantOrderNumber}</div>)
        },
        {
            accessor: [
                {
                    Header: "Durumu",
                    accessor: "status",
                    sortable: false,
                }
            ],
            Cell: row => (<div>{statusHepsiburada(row.status)}</div>)
        },
        {
            Header: "",
            accessor: "",
            sortable: false,
            width: "11%",
            Cell: (item, index) => (
                <div>
                    <button type="button" onClick={() => ciceksepetiDataToInvoiceData(item, index)} rel="tooltip"
                            className="Btn btn-icon" title="Fatura Gönder"
                            style={{background: 'rgb(52, 216, 103)'}}>
                        <i className="fa fa-send"/>
                    </button>
                </div>
            )
        }
    ];

    const columnsN11 = [
        {
            Header: "#",
            accessor: "recordId",
            sortable: false,
            Cell: (row, index) => (<div style={{margin: 0}}>{index + 1}</div>)
        },
        {
            accessor: [
                {
                    Header: "Sipariş Numarası",
                    accessor: "orderNumber",
                    sortable: false,
                }
            ],
            sort: false,
            Cell: row => (<div>{row.orderNumber}</div>)
        },
        {
            accessor: [
                {
                    Header: "Sipariş Tarihi",
                    accessor: "",
                    sortable: false,
                }
            ],
            sort: false,
            Cell: row => (<div>{row.createDate}</div>)
        },
        {
            accessor: [
                {
                    Header: "Durumu",
                    accessor: "status",
                    sortable: false,
                }
            ],
            Cell: row => (<div>{statusN11(row.status)}</div>)
        },
        {
            Header: "",
            accessor: "",
            sortable: false,
            width: "11%",
            Cell: (item, index) => (
                <div>
                    <button type="button" onClick={() => n11DataToInvoiceData(item, index)} rel="tooltip"
                            className="Btn btn-icon" title="Fatura Gönder"
                        // disabled={item.status === 1 || item.status === 2 ? false : true}
                            style={{background: 'rgb(52, 216, 103)'}}>
                        <i className="fa fa-send"/>
                    </button>
                </div>
            )
        }
    ];

    const columnsIkas = [
        {
            Header: "#",
            accessor: "recordId",
            sortable: false,
            Cell: (row, index) => (<div style={{margin: 0}}>{index + 1}</div>)
        },
        {
            accessor: [
                {
                    Header: "Sipariş Numarası",
                    accessor: "orderNumber",
                    sortable: false,
                }
            ],
            sort: false,
            Cell: row => (<div>{row.orderNumber}</div>)
        },
        {
            accessor: [
                {
                    Header: "Sipariş Tarihi",
                    accessor: "",
                    sortable: false,
                }
            ],
            sort: false,
            Cell: row => (<div>{moment(row.createdAt).format('DD-MM-YYYY')}</div>)
        },
        {
            accessor: [
                {
                    Header: "Durumu",
                    accessor: "status",
                    sortable: false,
                }
            ],
            Cell: row => (<div>{statusIkas(row.status)}</div>)
        },
        {
            accessor: [
                {
                    Header: "Fatura Tutarı",
                    accessor: "invoicePrice",
                    sortable: false,
                }
            ],
            Cell: row => (<div>{row.totalFinalPrice + " TRY"}</div>)
        },
        {
            Header: "",
            accessor: "",
            sortable: false,
            width: "11%",
            Cell: (item, index) => (
                <div>
                    <button type="button" onClick={() => ikasDataToInvoiceData(item, index)} rel="tooltip"
                            className="Btn btn-icon" title="Fatura Gönder"
                            disabled={item.status === 'CREATED' ? false : true}
                            style={{background: 'rgb(52, 216, 103)'}}>
                        <i className="fa fa-send"/>
                    </button>
                </div>
            )
        }
    ];

    const toDateTime = (time) => {
        const newTime = new Intl.DateTimeFormat('tr-TR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).format(time);

        const [day, month, year] = newTime.split('.');
        return `${day}-${month}-${year}`;
    }

    const fieldsTrendyolSearch = [
        {
            label: `Sipariş Durumu`,
            accessor: "status",
            type: "select",
            operator: "=",
            selectData: statusTrendyolData
        },
        {
            label: `Başlangıç Tarihi`,
            accessor: "startDate",
            type: "timestamp",
            operator: "=",
            disableAccessibleDate: true
        },
        {
            label: `Bitiş Tarihi`,
            accessor: "endDate",
            type: "timestamp",
            operator: "=",
            disableAccessibleDate: true
        },
        {
            label: `Sipariş Numarası`,
            accessor: "orderNumber",
            type: "text",
            operator: "="
        }
    ];

    const fieldsCiceksepetiSearch = [
        {
            label: `Sipariş Durumu`,
            accessor: "status",
            type: "select",
            operator: "=",
            selectData: statusCiceksepetiData
        },
        {
            label: `Başlangıç Tarihi`,
            accessor: "startDate",
            type: "datetime",
            operator: "=",
            disableAccessibleDate: true
        },
        {
            label: `Bitiş Tarihi`,
            accessor: "endDate",
            type: "datetime",
            operator: "=",
            disableAccessibleDate: true
        },
        {
            label: `Sipariş Numarası`,
            accessor: "orderNo",
            type: "numericText",
            operator: "="
        },
        {
            label: `Sipariş Aktif Mi`,
            accessor: "isOrderStatusActive",
            type: "select",
            operator: "=",
            selectData: [
                {value: null, label: 'Tümü'},
                {value: 'true', label: 'Aktif'},
                {value: 'false', label: 'Pasif'}
            ]
        }
    ];

    const fieldsPazaramaSearch = [
        {
            label: `Başlangıç Tarihi`,
            accessor: "startDate",
            type: "date",
            operator: "=",
            disableAccessibleDate: true
        },
        {
            label: `Bitiş Tarihi`,
            accessor: "endDate",
            type: "date",
            operator: "=",
            disableAccessibleDate: true
        }
    ];

    const fieldsHepsiburadaSearch = [
        {
            label: `Başlangıç Tarihi`,
            accessor: "startDate",
            type: "datetime",
            operator: "=",
            disableAccessibleDate: true
        },
        {
            label: `Bitiş Tarihi`,
            accessor: "endDate",
            type: "datetime",
            operator: "=",
            disableAccessibleDate: true
        },
        {
            label: `Sipariş Durumu`,
            accessor: "statusId",
            type: "select",
            operator: "=",
            selectData: statusHepsiburadaData
        },
        {
            label: `Sipariş Numarası`,
            accessor: "merchantOrderNumber",
            type: "numericText",
            operator: "="
        }
    ];

    const fieldsIkasSearch = [
        {
            label: `Sipariş Durumu`,
            accessor: "status",
            type: "select",
            operator: "=",
            selectData: statusIkasData
        },
    ];

    const fieldsN11Search = [
        {
            label: `Sipariş Durumu`,
            accessor: "status",
            type: "select",
            operator: "=",
            selectData: statusN11Data
        },
        {
            label: `Sipariş Numarası`,
            accessor: "orderNumber",
            type: "text",
            operator: "="
        }
    ];

    return (
        <div className="row baseBackground">
            <nav className="topbar filter-sticky-container">
                <div className="col-sm-12 row">
                    <div className="col-sm-8 row">
                        <StickButton
                            position="leftSide"
                            title="Seçilileri Gönder"
                            label="Seçilileri Gönder"
                            className={"stickButton send"}
                            icon='send'
                            onClick={() => sendMultiple({ showSendModal: true, sendType: "selected" })}
                            disabled={selection.length === 0 || selection.length > 1}
                        />

                        <StickButton position="leftSide"
                                     title="Tümünü Gönder"
                                     label="Tümünü Gönder"
                                     className={"stickButton send"}
                                     onClick={() => sendMultiple({ showSendModal: true, sendType: "all" })}
                                     disabled={selection.length === 0 || selection.length === 1}
                                     icon="send"
                        />
                    </div>
                </div>
            </nav>
            <div className="col-sm-12 satirBasi">
                <div className="card-body">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="" style={{marginTop: '10px', marginBottom: '10px'}}
                                 id="PayTrPrefixDetailedContainer">
                                {eCommerces.TRENDYOL === type &&
                                    <DetailedSearch fields={fieldsTrendyolSearch}
                                                    type={eCommerces.TRENDYOL}
                                                    loading={searching}
                                                    onSearch={handleSearch}
                                                    hasContainer="PayTrPrefixDetailedContainer"/>
                                }
                                {eCommerces.CICEKSEPETI === type &&
                                    <DetailedSearch fields={fieldsCiceksepetiSearch}
                                                    type={eCommerces.CICEKSEPETI}
                                                    loading={searching}
                                                    onSearch={handleSearch}
                                                    hasContainer="PayTrPrefixDetailedContainer"/>
                                }
                                {eCommerces.PAZARAMA === type &&
                                    <DetailedSearch fields={fieldsPazaramaSearch}
                                                    type={eCommerces.CICEKSEPETI}
                                                    loading={searching}
                                                    onSearch={handleSearch}
                                                    hasContainer="PayTrPrefixDetailedContainer"/>
                                }
                                {eCommerces.HEPSIBURADA === type &&
                                    <DetailedSearch fields={fieldsHepsiburadaSearch}
                                                    loading={searching}
                                                    onSearch={handleSearch}
                                                    hasContainer="PayTrPrefixDetailedContainer"/>
                                }
                                {eCommerces.IKAS === type &&
                                    <DetailedSearch fields={fieldsIkasSearch}
                                                    type={eCommerces.CICEKSEPETI}
                                                    loading={searching}
                                                    onSearch={handleSearch}
                                                    hasContainer="PayTrPrefixDetailedContainer"/>
                                }
                                {eCommerces.N11 === type &&
                                    <DetailedSearch fields={fieldsN11Search}
                                                    type={eCommerces.CICEKSEPETI}
                                                    loading={searching}
                                                    onSearch={handleSearch}
                                                    hasContainer="PayTrPrefixDetailedContainer"/>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className=" row">
                        <div className="col-sm-12" style={{float: 'right'}}>

                        </div>
                    </div>
                    <div className=" row">
                        {type === eCommerces.TRENDYOL &&
                            <div className="col-sm-12">
                                <Table columns={columnsTrendyol}
                                       loading={loading}
                                       loadingText="Kayıtlar Getiriliyor..."
                                       content={content}
                                       total={total}
                                       page={page}
                                       size={size}
                                       options={["5", "10", "20", "50", "100"]}
                                       fetchData={fetchDataTrendyol}
                                />
                            </div>}
                        {type === eCommerces.CICEKSEPETI &&
                            <div className="col-sm-12">
                                <Table columns={columnsCiceksepeti}
                                       loading={loading}
                                       loadingText="Kayıtlar Getiriliyor..."
                                       content={content}
                                       total={total}
                                       page={page}
                                       size={size}
                                       options={["5", "10", "20", "50", "100"]}
                                       fetchData={fetchDataCiceksepeti}
                                />
                            </div>}
                        {type === eCommerces.HEPSIBURADA &&
                            <div className="col-sm-12">
                                <Table columns={columnsHepsiburada}
                                       loading={loading}
                                       loadingText="Kayıtlar Getiriliyor..."
                                       content={content}
                                       total={total}
                                       page={page}
                                       size={size}
                                       options={["5", "10", "20", "50", "100"]}
                                       fetchData={fetchDataHepsiburada}
                                />
                            </div>}
                        {type === eCommerces.N11 &&
                            <div className="col-sm-12">
                                <Table columns={columnsN11}
                                       loading={loading}
                                       loadingText="Kayıtlar Getiriliyor..."
                                       content={content}
                                       total={total}
                                       page={page}
                                       size={size}
                                       options={["5", "10", "20", "50", "100"]}
                                       fetchData={fetchDataN11}
                                />
                            </div>}
                        {type === eCommerces.PAZARAMA &&
                            <div className="col-sm-12">
                                <Table columns={columnsPazarama}
                                       loading={loading}
                                       loadingText="Kayıtlar Getiriliyor..."
                                       content={content}
                                       total={total}
                                       page={page}
                                       size={size}
                                       options={["5", "10", "20", "50", "100"]}
                                       fetchData={fetchDataPazarama}
                                />
                            </div>}
                        {type === eCommerces.IKAS &&
                            <div className="col-sm-12">
                                <Table columns={columnsIkas}
                                       loading={loading}
                                       loadingText="Kayıtlar Getiriliyor..."
                                       content={content}
                                       total={total}
                                       page={page}
                                       size={size}
                                       options={["5", "10", "20", "50", "100"]}
                                       fetchData={fetchDataIkas}
                                />
                            </div>}
                        {showSendSwal &&
                            <DefaultModal
                                isOpen={showSendSwal}
                                title={"Kullanmak İstediğiniz Öneki Seçiniz"}
                                confirmBtnText="Gönder"
                                cancelBtnText="İptal"
                                onConfirm={confirmSend()}
                                onCancel={(e) => setShowSendSwal(false)}
                            >
                                <div className="col-sm-12">
                                    <h5 style={{
                                        fontFamily: 'Century Gothic',
                                        fontSize: '1em',
                                        fontWeight: 100,
                                        textAlign: "center"
                                    }}
                                        className="text-danger">{documentId}</h5>
                                </div>
                                <div className="col-sm-12">
                                    <Select
                                        value={documentId}
                                        clearable={false}
                                        placeholder="Seçiniz..."
                                        noResultsText="Kayıt bulunamadı."
                                        onChange={(e) => {
                                            setDocumentId(e.value);
                                            setLastIssueDate(e.lastIssueDate);
                                        }}
                                        options={prefixCodes.map(prefixCode => ({
                                            value: prefixCode.value,
                                            label: (props.isEczaciKart ? prefixCode.prefix : prefixCode.label),
                                            lastIssueDate: prefixCode.lastIssueDate
                                        }))}
                                    />
                                </div>
                            </DefaultModal>
                        }
                        {mediaModal &&
                            <MediaViewer modal={mediaModal}
                                         url={url}
                                         title={title}
                                         listener={setMediaViewer}
                                         selectedItem={selectedItem}
                                         selectedIndex={selectedIndex}
                                         currentUser={props.currentUser}
                                         location='tmpInvoice'
                                         downloadMedia={downloadMedia}
                                         handleSend={sendFromViewer}
                            />
                        }
                        {showSendModal &&
                            <TrendyolSendMultipleModal
                                type="invoice"
                                profileId={props.profileId}
                                recordIds={selection}
                                sendType={sendType}
                                currentUser={props.currentUser}
                                toggleModal={(flag, manual) => {
                                    setShowSendModal(flag);
                                    setManual(manual);
                                }}
                                title={sendType === "all" ? "Faturaların Tümünü Gönderme İşlemi" : "Seçili Faturaları Gönderme İşlemi"}
                                modal={showSendModal}/>
                        }

                    </div>
                </div>
            </div>
            {showDeleteSwal &&
                <SweetAlert
                    showCancel
                    closeOnClickOutside={false}
                    hideOverlay={false}
                    // disabled={this.state.deleteBtnDisabled}
                    confirmBtnText="Evet"
                    confirmBtnCssClass="TekBtn gonder"
                    confirmBtnStyle={{float: 'right'}}
                    cancelBtnText="Hayır"
                    cancelBtnCssClass="TekBtn vazgec"
                    cancelBtnStyle={{
                        background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                        float: 'left'
                    }}
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="default"
                    title="Silme Onayı"
                    style={{width: 400}}
                    onConfirm={deleteInvoiceLink}
                    onCancel={() => setShowDeleteSwal(false)}
                >
                    Fatura Linkinin silinmesini onaylıyor musunuz?
                </SweetAlert>
            }
            {sendLoading && <ReactLoadingTop style={{width: '90px', height: '90px'}}/>}
            <Modal isOpen={istisnaModal} size="md">
                <ModalHeader
                    className="justify-content-center">
                    İstisna Durum Bilgileri
                </ModalHeader>
                <ModalBody>
                    <div>
                        <FormGroup row style={{textAlign: 'center'}}>
                            <Label sm={12} for="formattedName" style={{fontWeight: 'bold', fontSize: '16px'}}>Lütfen
                                istisna durum bilgilerinizi doldurunuz.</Label>
                        </FormGroup>
                        <FormGroup row>
                            <Label sm={4} for="username">İstisna Durumu: *</Label>
                            <Col sm={8}>
                                <Input
                                    type="select"
                                    name="istisnaDurumu"
                                    value={istisnaStatus}
                                    onChange={e => {
                                        setIstisnaStatus(e.target.value);
                                        setIstisnaModal(false);
                                        sendIstisnaData(e.target.value);
                                    }}
                                >
                                    <option value="">Seçiniz</option>
                                    <option value="350">İstisna Diğer</option>
                                    <option value="351">İstisna Olmayan Diğer</option>
                                </Input>
                            </Col>
                        </FormGroup>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    )
}
export default ECommerce;